import { useState, useCallback } from "react";
import { getEvaluationProcessList } from "@/apis/supplier";
import { message } from "antd";
import type { BackendEvaluationNode } from "./useEvaluationCategoryTransform";

// ==================== 类型定义 ====================
export interface EvaluationProcessItem {
  id: string;
  name: string;
  // 根据实际接口响应添加其他字段
  [key: string]: any;
}

interface EvaluationProcessParams {
  materialTypeId: string;
  deptId: string;
}

// ==================== 自定义Hook ====================
/**
 * 获取评估流程列表的Hook
 * @returns {Object} 返回评估流程数据、加载状态、加载函数和清空函数
 */
export const useEvaluationProcess = () => {
  const [processList, setProcessList] = useState<BackendEvaluationNode[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchEvaluationProcess = useCallback(
    (params: EvaluationProcessParams): Promise<BackendEvaluationNode[]> => {
      return new Promise((resolve, reject) => {
        setLoading(true);
        getEvaluationProcessList(params.materialTypeId, params.deptId)
          .then((response) => {
            // 接口返回 { data: [...] } 或 { data: { data: [...] } }
            const data = response.data?.data || response.data || [];

            if (Array.isArray(data)) {
              setProcessList(data);
              resolve(data);
            } else {
              setProcessList([]);
              resolve([]);
            }
          })
          .catch((error) => {
            message.error("获取评估流程列表失败");
            setProcessList([]);
            reject(error);
          })
          .finally(() => {
            setLoading(false);
          });
      });
    },
    [],
  );

  // 清空评估流程数据
  const clearProcessList = useCallback(() => {
    setProcessList([]);
  }, []);

  return { processList, loading, fetchEvaluationProcess, clearProcessList };
};
